import { render, staticRenderFns } from "./SpeciesView.vue?vue&type=template&id=60cc5f04&scoped=true"
import script from "./SpeciesView.vue?vue&type=script&lang=js"
export * from "./SpeciesView.vue?vue&type=script&lang=js"
import style0 from "./SpeciesView.vue?vue&type=style&index=0&id=60cc5f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cc5f04",
  null
  
)

export default component.exports